// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-switch-checked .ant-switch-handle {
  border-color: #ffffff;
}

.toggle-filters {
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.product-card-desk {
  width: 100%;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
  cursor: pointer;
}

.product-sh {
  height: 90px;
}

.product-item {
  padding: 5px;
  transition:
    background-color 0.3s ease,
    transform 0.3s ease;
}

.product-item.highlight {
  transform: scale(1.02);
  border-color: transparent;
  box-shadow:
    0 1px 2px -2px rgba(0, 0, 0, 0.16),
    0 3px 6px 0 rgba(0, 0, 0, 0.12),
    0 5px 12px 4px rgba(0, 0, 0, 0.09);
}

.sh-row {
  height: 90px;
  margin-left: 4.5rem;
}

.border-line-sh {
  border: 1px solid #d2d2d2;
  width: 100%;
}

.products-list-subcontainer {
  /* margin-bottom: 20px; */
  padding-left: 1%;
  width: 100%;
  margin-top: 2%;
}

.tooltip-product-card {
  margin: 0;
  text-wrap: auto;
  font-family: Roboto;
}

.cards-container {
  width: 76vw;
}

/* product listing card css*/

.pricing-card .ant-card .ant-card-body {
  padding-top: 15px !important;
  border-radius: 0 0 8px 8px;
}

.product-image-div {
  padding: 0px 0px 0px 0px;
}

.product-image {
  width: 100% !important;
  height: 100% !important;
  border-radius: 5px !important;
}

.vertical-line {
  margin: "0px auto";
  width: 1px;
  height: 2cm;
  background-color: #b3b5b4;
  margin-top: 5px;
}

.product-id {
  font-family: Roboto;
  font-size: 13px;
  color: #8e9190;
  padding-right: 29%;
}

.product-card .product-title {
  font-size: 19px;
  font-weight: bold;
}

.available-txt {
  font-family: Roboto;
  font-size: 13px;
  color: var(--Colors-Text-300, #5b5e5d);
}

.product-availability {
  font-family: Roboto;
  display: flex;
  font-size: 16px;
}

.product-availability-desk {
  display: flex;
  font-size: 14px;
}

.product-size-img {
  width: 28px;
  height: 27px;
  color: #5b5e5d;
}

.product-size-text {
  font-family: Roboto;
  font-size: 16px;
  color: #5b5e5d !important;
}

.products-metric-icon {
  width: 24px;
  height: 24px;
}

.product-reach {
  font-family: Roboto;
  font-size: 16px;
  color: #5b5e5d !important;
}

.product-type {
  font-family: Roboto;
  font-size: 16px;
  color: #5b5e5d !important;
}

.product-last-section-detail {
  display: flex;
  justify-content: end;
  padding-top: 10px;
  align-items: baseline;
}

.product-last-section-detail .price-range {
  position: relative;
  margin-top: 0.2rem;
  width: max-content;
}

.product-last-section-detail-miles {
  display: none !important;
}

.termsplan-section {
  display: flex;
  padding-bottom: 15px;
  align-items: flex-end;
  justify-content: flex-end;
}

.badge-icon {
  width: 15px;
}

.terms-plan-txt {
  color: #d2042d;
  font-size: 16px;
}

.bookmark-icon {
  width: 15px;
}

.procduct-price-detail-section {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-end !important;
}

.price-text {
  font-family: Roboto;
  color: #000;
  font-size: 23px;
  font-weight: 700 !important;
}

.ai-price {
  font-size: 16px;
  text-decoration: underline;
  color: #d2042d;
  cursor: pointer;
}

.ai-badge {
  font-weight: 400;
  font-size: 13px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #000;
  pointer-events: none;
  padding: 0.4rem 0.6rem;
  margin-bottom: 0.6rem;
  background-color: #f5f5f5;
}

.per-week {
  font-family: Roboto;
  font-size: 13px;
  color: #8e9190;
}

.details-btn {
  height: 40px;
  width: 130px;
}

.ant-pagination:not(.ant-pagination-disabled) .ant-pagination-item:focus-visible {
  outline: 2px solid #d2042d;
  outline-offset: 1px;
  transition:
    outline-offset 0s,
    outline 0s;
}

.delete-all {
  display: flex;
  gap: 7px;
  margin: 35px 0 0 1px;
  font-size: 14px;
  align-items: center;
  text-decoration: underline;
  font-family: 'Roboto';
}

.ant-pagination .ant-pagination-item-active {
  font-weight: 600;
  background-color: #ffffff;
  border-color: #ffffff;
}

.ant-pagination .ant-pagination-item-active a {
  color: #d2042d;
}

.middle-specification {
  margin-top: 0.7rem;
  background-color: #f8f8f8 !important;
  display: flex;
  height: auto;
  padding: 21px 34px 20px 34px;
  justify-content: space-between;
}

.product-card {
  margin-bottom: 2%;
}

.format-arrow {
  padding-top: 3px;
  padding-inline: 3px;
}

.people-views {
  display: inline;
  color: var(--Colors-Text-200, #8e9190);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.price-section {
  display: flex;
  align-items: flex-end;
}

.product-last-section-detail-card {
  display: none !important;
}

.product-last-section-detail-map {
  display: flex;
  justify-content: center;
  align-items: center;
}

.middle-specification {
  margin-top: 0.7rem;
  background-color: #f8f8f8 !important;
  display: flex;
  height: auto;
  padding: 21px 34px 20px 34px;
  justify-content: space-between;
}

.divider-line {
  color: #000;
}

.people-views {
  display: inline;

  color: var(--Colors-Text-200, #8e9190);

  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.price-section {
  display: flex;
  align-items: flex-end;
}

.product-last-section-detail-card {
  display: none !important;
}

.product-card-city {
  font-family: Roboto;
  font-size: 14px;
  color: #000;
}

.product-last-section-detail-map {
  display: flex;
  justify-content: center;
  align-items: center;
}

.copy-icon {
  cursor: pointer !important;
  color: #5a5656ff !important;
  opacity: 0 !important;
  transition: opacity 0.2s ease-in-out !important;
  margin-left: 10px !important;
}

.product-copy-text-field {
  display: flex !important;
  align-items: center !important;
}

.product-copy-text-field-full>span {
  width: 100% !important;
}

.product-copy-text-field {
  display: flex !important;
  align-items: center !important;
}

.product-copy-text-field .copy-icon {
  cursor: pointer !important;
  color: #5a5656 !important;
  opacity: 0 !important;
  visibility: hidden !important;
  transition: opacity 0.2s ease-in-out !important;
  margin-left: 10px !important;
  display: inline-block !important;
}

.product-copy-text-field:hover .copy-icon {
  opacity: 1 !important;
  visibility: visible !important;
}

.estimated-price-content {
  display: "flex" !important;
  align-items: "center" !important;
  background: "#f5f5f5" !important;
  padding: "0.4rem 0.6rem" !important;
  margin-bottom: "0.8rem" !important;
}

.procduct-price-detail-section .ant-image {
  right: 0.2rem;
}

.procduct-price-detail-section .sparkles {
  z-index: 2;
  position: relative;
}

.procduct-price-detail-section .range-section {
  margin-top: 0.6rem;
}

.procduct-price-detail-section sup .ant-badge-count {
  color: #000;
  padding: 1rem;
  display: flex;
  align-items: center;
  text-align: center;
  padding-left: 1rem;
}

.product-card-badge {
  padding: 0.5rem 0.2rem;
  border-radius: 5px;
}

.product-card-format-dates-div {
  display: flex;
  align-items: center;
}

.product-card-divider-css {
  height: 90px;
  border-color: #b3b5b4;
}

.product-card-loader {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 4rem;
  margin-bottom: 1rem;
}

.card-tooltip {
  color: rgba(0, 0, 0, 0.85) !important;
}

.not-available-txt {
  display: flex;
  width: 10.6875rem;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  color: #0a0f0d;
  border-radius: 0.3125rem;
  background: var(--Premium, #ffd700);
}

.not-available-badge {
  position: "absolute" !important;
  right: 8 !important;
  background-color: "#ffe1e6" !important;
  color: "#d93025" !important;
  font-weight: "600";
  font-size: 12;
  padding: "8px";
  border-radius: 3;
  -webkit-user-select: "none";
          user-select: "none";
  pointer-events: "none";
  white-space: "nowrap";
}

.notify-me {
  font-family: Roboto !important;
  font-weight: 500 !important;
  font-style: Medium !important;
  font-size: 16px !important;
  line-height: 100%;
  letter-spacing: 0%;
  text-decoration: underline !important;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  text-decoration-skip-ink: auto;
  background: none;
  color: #d2042d !important;
}

.add-product-section {
  margin-top: 20px;
  display: flex;
  align-items: center;
}

.product-recomended-type {
  font-family: Roboto;
  font-weight: 400;
  font-style: Medium;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  text-decoration: underline !important;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  text-decoration-skip-ink: auto;
  background: none;
  color: #d2042d !important;
}

.notify-section {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 14px;
}

.price-range-mobile {
  position: relative !important;
  margin-top: 0.2rem;
  width: max-content;
}

.estimated-header {
  width: max-content;
}

@media (max-width: 1440px) {
  .toggle-filters {
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
  }

  .product-last-section-detail-card {
    display: none !important;
  }

  .product-card {
    width: 100%;
    height: auto;
    margin-top: 2%;
  }

  .product-image {
    width: 100% !important;
    height: 100% !important;
  }

  .product-bill-image {
    width: 28px;
    height: 27px;
  }

  .product-id {
    font-size: 13px;
    color: #8e9190;
    padding-right: 30%;
  }

  .product-availability-desk {
    display: flex;
    font-size: 14px !important;
  }

  .product-card .product-title {
    font-size: 16px;
    font-weight: bold;
  }

  .available-txt {
    font-size: 13px;
  }

  .product-availability {
    font-size: 16px;
  }

  .product-size-img {
    width: 28px;
    height: 27px;
  }

  .product-size-text {
    font-size: 16px;
  }

  .products-metric-icon {
    width: 24px;
    height: 24px;
  }

  .product-reach {
    font-size: 16px;
  }

  .product-type {
    font-size: 16px;
  }

  .product-last-section-detail {
    display: flex;
    justify-content: end;
    padding-top: 10px;
    align-items: baseline;
  }

  .termsplan-section {
    display: flex;
    padding-bottom: 15px;
    align-items: flex-end;
  }

  .badge-icon {
    width: 15px;
  }

  .terms-plan-txt {
    color: #d2042d;
    font-size: 15px;
  }

  .bookmark-icon {
    width: 15px;
  }

  .procduct-price-detail-section {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-end !important;
  }

  .price-text {
    color: black;
    font-size: 23px;
  }

  .per-week {
    font-size: 13px;
    color: #8e9190;
  }

  .middle-specification {
    margin-top: 0.7rem;
    background-color: #f8f8f8 !important;
    display: flex;
    height: auto;
    padding: 21px 34px 20px 34px;
    justify-content: space-between;
  }
}

@media (max-width: 1370px) {
  .product-card-city {
    font-family: Roboto;
    font-size: 14px;
    color: #000;
  }

  .copy-icon {
    margin-left: 0px;
  }
}

@media (max-width: 1280px) {
  .terms-plan-txt {
    color: #d2042d;
    font-size: 13px;
  }

  .product-availability {
    font-size: 13px;
  }

  .product-id {
    font-family: Roboto;
    font-size: 13px;
    color: #8e9190;
    padding-right: 0% !important;
  }

  .product-image {
    width: 100% !important;
    height: 100% !important;
  }

  .format-arrow {
    padding-top: 2px;
    padding-inline: 3px;
  }

  .toggle-filters {
    color: #000;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .product-availability-desk {
    display: flex;
    font-size: 12px !important;
  }

  .middle-specification {
    margin-top: 0.7rem;
    background-color: #f8f8f8 !important;
    display: flex;
    height: auto;
    padding: 21px 4px 20px 4px;
    justify-content: space-between;
  }

  .product-size-text {
    font-size: 13px;
  }

  .product-reach {
    font-size: 13px;
  }

  .product-type {
    font-size: 13px;
  }

  .cards-container {
    width: 100%;
  }
}

@media (max-width: 1024px) {
  .product-page {
    padding-left: 10px;
    padding-right: 2% !important;
  }

  .cards-container {
    width: 96vw;
  }

  /* product listing card css*/
  .product-size-text {
    font-size: 13px;
  }

  .product-image {
    width: 100% !important;
    height: 100% !important;
    padding: 0px 6px;
    border-radius: 11px !important;
  }

  .product-id {
    font-size: 13px;
    color: #8e9190;
    padding-right: 4%;
  }

  .price-text {
    color: black;
    font-size: 21px;
  }

  .ant-select-dropdown .ant-select-item-option-content {
    font-size: 16px !important;
  }

  .product-card .ant-select-outlined:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):hover .ant-select-selector {
    border-color: #c7cac9 !important;
  }

  .badge-icon {
    width: 14px !important;
  }

  .terms-plan-txt {
    color: #d2042d;
    font-size: 13px;
  }

  .bookmark-icon {
    width: 13px !important;
  }

  .product-availability {
    font-size: 14px;
  }

  .format-arrow {
    padding-top: 3px;
    padding-inline: 3px;
  }

  .product-last-section-detail-card {
    display: none !important;
  }
}

@media (max-width: 768px) {
  .product-title-mobile-view {
    font-size: 14px;
  }

  .border-line-sh {
    display: none;
  }

  .products-list-subcontainer {
    display: none !important;
  }

  .location-card .ant-card .ant-card-body {
    padding: 10px !important;
  }

  .map-location-icon {
    width: 28px !important;
    height: 28px !important;
  }

  .cards-container {
    width: 93.5vw;
  }

  .product-last-section-detail-miles {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    padding-top: 40px !important;
  }

  .product-image {
    width: 100% !important;
    height: 100% !important;
  }

  .product-id {
    font-size: 14px;
    color: #d2042d;
  }

  .product-card .product-title {
    font-size: 20px;
    font-weight: bold;
  }

  .available-txt {
    font-size: 15px;
    color: #8e9190;
  }

  .middle-specification {
    margin-top: 0.7rem;
    background-color: #f8f8f8 !important;
    display: flex;
    height: auto;
    padding: 21px 34px 20px 34px;
    justify-content: space-between;
  }

  .product-availability {
    font-size: 16px;
    font-weight: 500;
  }

  .available-container {
    padding-top: 7px !important;
  }

  .product-size-text {
    font-size: 15px;
    padding-top: 10px;
  }

  .product-reach {
    font-size: 15px;
    padding-top: 10px;
  }

  .product-type {
    font-size: 15px;
    padding-top: 10px;
  }

  .product-last-section-detail-card {
    display: flex !important;
    justify-content: end !important;
    height: 60px !important;
    padding-top: 20px !important;
    align-items: baseline !important;
  }

  .product-last-section-detail-map {
    display: none !important;
  }

  .product-card .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
    background-color: none;
    border: none;
    width: none !important;
    height: 50px;
    margin-top: 0rem !important;
    color: rgb(12, 12, 12);
  }

  .ant-btn:not(:disabled):focus-visible {
    outline: none !important;
    outline-offset: 01px !important;
    transition: none !important;
  }

  .price-section {
    display: flex;
    align-items: flex-end;
  }

  .navigation-icon {
    width: 15px !important;
  }

  .miles-text {
    font-family: Roboto;
    color: #8e9190;
    font-size: 15px;
  }

  .bookmark-icon {
    margin-left: 8rem !important;
    width: 17px !important;
  }

  .price-text {
    color: black;
    font-size: 20px;
  }

  .ant-pagination:not(.ant-pagination-disabled) .ant-pagination-item:focus-visible {
    outline: 1px solid #d2042d;
    outline-offset: 1px;
    transition:
      outline-offset 0s,
      outline 0s;
  }

  .ant-pagination .ant-pagination-item-active {
    font-weight: 600;
    background-color: #ffffff;
    border-color: #fff;
  }

  .ant-pagination .ant-pagination-item-active a {
    color: #d2042d;
  }

  .product-last-section-detail {
    display: flex !important;
    justify-content: center;
    align-items: center;
  }

  .product-last-section-detail-map {
    display: none !important;
  }
}

@media (max-width: 425px) {
  .product-page .ant-card .ant-card-body {
    padding: 14px;
    border-radius: 18 0 8px 8px;
  }

  .product-card .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
    background-color: none;
    border: none;
    width: none !important;
    height: 40px;
    margin-top: 0rem !important;
    color: rgb(12, 12, 12);
  }

  .map-location-icon {
    width: 24px !important;
    height: 24px !important;
  }

  .map-location-icon {
    width: 24px !important;
    height: 24px !important;
  }

  .product-image {
    width: 100% !important;
    height: 100% !important;
  }

  .product-id {
    font-size: 13px !important;
    color: #d2042d;
    font-weight: 500;
  }

  .bookmark-icon {
    margin-left: 41px !important;
    width: 17px !important;
  }

  .product-card .product-title {
    font-size: 16px !important;
    font-weight: bold;
  }

  .available-txt {
    font-size: 13px;
    color: #8e9190;
  }

  .product-availability {
    font-size: 13px;
    font-weight: 600;
    display: flex;
  }

  .middle-specification {
    display: flex;
    height: 100%;
    padding: 21px 0px 20px 0px !important;
    justify-content: space-evenly;
    flex-shrink: 0;
  }

  .product-size-img {
    width: 20px;
    height: 19px;
  }

  .product-size-text {
    font-size: 13px;
    text-align: center;
  }

  .products-metric-icon {
    width: 20px;
    height: 20px;
  }

  .product-reach {
    font-size: 13px;
  }

  .product-type {
    font-size: 13px;
  }

  .navigation-icon {
    width: 13px !important;
  }

  .miles-text {
    color: #8e9190;
    font-size: 13px;
  }

  .price-text {
    color: black;
    font-size: 19px;
    font-weight: 700 !important;
  }
}

@media (max-width: 375px) {
  .product-image {
    width: 100% !important;
    height: 100% !important;
    border-radius: 10px !important;
  }

  .available-container {
    padding-top: 0px !important;
  }

  .bookmark-icon {
    margin-left: 18px !important;
    width: 17px !important;
  }

  .middle-specification {
    display: flex;
    height: auto;
    padding: 15px 0px 19px 0px !important;
    justify-content: space-evenly;
    flex-shrink: 0;
  }
}

@media (max-width: 360px) {
  .bookmark-icon {
    margin-left: 8px !important;
    width: 17px !important;
  }

  .product-availability-desk {
    display: flex;
    font-size: 13px !important;
  }

  .per-week {
    font-size: 11px;
    color: #8e9190;
  }
}

/* CSS for the Desktop Product Details Modal */
.divider-line {
  margin-top: 20px;
  width: 100%;
  border: 1px solid #d2d2d2;
}

.close-icon {
  color: #d2042d;
  font-size: 30px;
  justify-content: center;
  font-weight: 3px;
}

.checkboard-availability-heading {
  display: flex;
  align-items: center;
  width: 100%;
  color: #000;
  font-family: Roboto;
  font-size: 23px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding-top: 2rem;
  padding-left: 1.8rem;
  padding-bottom: 0.1rem;
}

.modal-style .ant-modal-content {
  display: flex;
  box-shadow: none !important;
  padding: 0px !important;
  padding-top: 30px;
  height: auto;
  justify-content: center !important;
  width: 100%;
  overflow-y: auto;
  flex-direction: column;
  border-radius: 10px;
  background: #fff;
}

.mobile-promo {
  min-width: 0;
  width: 96%;
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/common/products/ProductCard.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ;;uBAEqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB;;;sCAGoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA,4BAA4B;;AAE5B;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB;;cAEY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;;EAEf,sCAAsC;;EAEtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;EACrB,+CAA+C;EAC/C,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;EAC7B,+CAA+C;EAC/C,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,gCAAgC;EAChC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,sCAAsC;EACtC,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,2BAAmB;UAAnB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,gCAAgC;EAClC;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,oCAAoC;IACpC,aAAa;IACb,YAAY;IACZ,4BAA4B;IAC5B,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,oCAAoC;IACpC,aAAa;IACb,YAAY;IACZ,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,WAAW;EACb;;EAEA,4BAA4B;EAC5B;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,kCAAkC;IAClC,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,oCAAoC;IACpC,aAAa;IACb,YAAY;IACZ,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,+BAA+B;IAC/B,uBAAuB;IACvB,4BAA4B;IAC5B,gCAAgC;EAClC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,+BAA+B;IAC/B,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;IACnB;;gBAEY;EACd;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,qCAAqC;IACrC,6BAA6B;IAC7B,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,qCAAqC;IACrC,6BAA6B;IAC7B,cAAc;EAChB;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;AACF;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,kCAAkC;EAClC,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB","sourcesContent":[".ant-switch-checked .ant-switch-handle {\n  border-color: #ffffff;\n}\n\n.toggle-filters {\n  color: #000;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.product-card-desk {\n  width: 100%;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n}\n\n.product-sh {\n  height: 90px;\n}\n\n.product-item {\n  padding: 5px;\n  transition:\n    background-color 0.3s ease,\n    transform 0.3s ease;\n}\n\n.product-item.highlight {\n  transform: scale(1.02);\n  border-color: transparent;\n  box-shadow:\n    0 1px 2px -2px rgba(0, 0, 0, 0.16),\n    0 3px 6px 0 rgba(0, 0, 0, 0.12),\n    0 5px 12px 4px rgba(0, 0, 0, 0.09);\n}\n\n.sh-row {\n  height: 90px;\n  margin-left: 4.5rem;\n}\n\n.border-line-sh {\n  border: 1px solid #d2d2d2;\n  width: 100%;\n}\n\n.products-list-subcontainer {\n  /* margin-bottom: 20px; */\n  padding-left: 1%;\n  width: 100%;\n  margin-top: 2%;\n}\n\n.tooltip-product-card {\n  margin: 0;\n  text-wrap: auto;\n  font-family: Roboto;\n}\n\n.cards-container {\n  width: 76vw;\n}\n\n/* product listing card css*/\n\n.pricing-card .ant-card .ant-card-body {\n  padding-top: 15px !important;\n  border-radius: 0 0 8px 8px;\n}\n\n.product-image-div {\n  padding: 0px 0px 0px 0px;\n}\n\n.product-image {\n  width: 100% !important;\n  height: 100% !important;\n  border-radius: 5px !important;\n}\n\n.vertical-line {\n  margin: \"0px auto\";\n  width: 1px;\n  height: 2cm;\n  background-color: #b3b5b4;\n  margin-top: 5px;\n}\n\n.product-id {\n  font-family: Roboto;\n  font-size: 13px;\n  color: #8e9190;\n  padding-right: 29%;\n}\n\n.product-card .product-title {\n  font-size: 19px;\n  font-weight: bold;\n}\n\n.available-txt {\n  font-family: Roboto;\n  font-size: 13px;\n  color: var(--Colors-Text-300, #5b5e5d);\n}\n\n.product-availability {\n  font-family: Roboto;\n  display: flex;\n  font-size: 16px;\n}\n\n.product-availability-desk {\n  display: flex;\n  font-size: 14px;\n}\n\n.product-size-img {\n  width: 28px;\n  height: 27px;\n  color: #5b5e5d;\n}\n\n.product-size-text {\n  font-family: Roboto;\n  font-size: 16px;\n  color: #5b5e5d !important;\n}\n\n.products-metric-icon {\n  width: 24px;\n  height: 24px;\n}\n\n.product-reach {\n  font-family: Roboto;\n  font-size: 16px;\n  color: #5b5e5d !important;\n}\n\n.product-type {\n  font-family: Roboto;\n  font-size: 16px;\n  color: #5b5e5d !important;\n}\n\n.product-last-section-detail {\n  display: flex;\n  justify-content: end;\n  padding-top: 10px;\n  align-items: baseline;\n}\n\n.product-last-section-detail .price-range {\n  position: relative;\n  margin-top: 0.2rem;\n  width: max-content;\n}\n\n.product-last-section-detail-miles {\n  display: none !important;\n}\n\n.termsplan-section {\n  display: flex;\n  padding-bottom: 15px;\n  align-items: flex-end;\n  justify-content: flex-end;\n}\n\n.badge-icon {\n  width: 15px;\n}\n\n.terms-plan-txt {\n  color: #d2042d;\n  font-size: 16px;\n}\n\n.bookmark-icon {\n  width: 15px;\n}\n\n.procduct-price-detail-section {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: flex-end !important;\n}\n\n.price-text {\n  font-family: Roboto;\n  color: #000;\n  font-size: 23px;\n  font-weight: 700 !important;\n}\n\n.ai-price {\n  font-size: 16px;\n  text-decoration: underline;\n  color: #d2042d;\n  cursor: pointer;\n}\n\n.ai-badge {\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: #000;\n  pointer-events: none;\n  padding: 0.4rem 0.6rem;\n  margin-bottom: 0.6rem;\n  background-color: #f5f5f5;\n}\n\n.per-week {\n  font-family: Roboto;\n  font-size: 13px;\n  color: #8e9190;\n}\n\n.details-btn {\n  height: 40px;\n  width: 130px;\n}\n\n.ant-pagination:not(.ant-pagination-disabled) .ant-pagination-item:focus-visible {\n  outline: 2px solid #d2042d;\n  outline-offset: 1px;\n  transition:\n    outline-offset 0s,\n    outline 0s;\n}\n\n.delete-all {\n  display: flex;\n  gap: 7px;\n  margin: 35px 0 0 1px;\n  font-size: 14px;\n  align-items: center;\n  text-decoration: underline;\n  font-family: 'Roboto';\n}\n\n.ant-pagination .ant-pagination-item-active {\n  font-weight: 600;\n  background-color: #ffffff;\n  border-color: #ffffff;\n}\n\n.ant-pagination .ant-pagination-item-active a {\n  color: #d2042d;\n}\n\n.middle-specification {\n  margin-top: 0.7rem;\n  background-color: #f8f8f8 !important;\n  display: flex;\n  height: auto;\n  padding: 21px 34px 20px 34px;\n  justify-content: space-between;\n}\n\n.product-card {\n  margin-bottom: 2%;\n}\n\n.format-arrow {\n  padding-top: 3px;\n  padding-inline: 3px;\n}\n\n.people-views {\n  display: inline;\n  color: var(--Colors-Text-200, #8e9190);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.price-section {\n  display: flex;\n  align-items: flex-end;\n}\n\n.product-last-section-detail-card {\n  display: none !important;\n}\n\n.product-last-section-detail-map {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.middle-specification {\n  margin-top: 0.7rem;\n  background-color: #f8f8f8 !important;\n  display: flex;\n  height: auto;\n  padding: 21px 34px 20px 34px;\n  justify-content: space-between;\n}\n\n.divider-line {\n  color: #000;\n}\n\n.people-views {\n  display: inline;\n\n  color: var(--Colors-Text-200, #8e9190);\n\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.price-section {\n  display: flex;\n  align-items: flex-end;\n}\n\n.product-last-section-detail-card {\n  display: none !important;\n}\n\n.product-card-city {\n  font-family: Roboto;\n  font-size: 14px;\n  color: #000;\n}\n\n.product-last-section-detail-map {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.copy-icon {\n  cursor: pointer !important;\n  color: #5a5656ff !important;\n  opacity: 0 !important;\n  transition: opacity 0.2s ease-in-out !important;\n  margin-left: 10px !important;\n}\n\n.product-copy-text-field {\n  display: flex !important;\n  align-items: center !important;\n}\n\n.product-copy-text-field-full>span {\n  width: 100% !important;\n}\n\n.product-copy-text-field {\n  display: flex !important;\n  align-items: center !important;\n}\n\n.product-copy-text-field .copy-icon {\n  cursor: pointer !important;\n  color: #5a5656 !important;\n  opacity: 0 !important;\n  visibility: hidden !important;\n  transition: opacity 0.2s ease-in-out !important;\n  margin-left: 10px !important;\n  display: inline-block !important;\n}\n\n.product-copy-text-field:hover .copy-icon {\n  opacity: 1 !important;\n  visibility: visible !important;\n}\n\n.estimated-price-content {\n  display: \"flex\" !important;\n  align-items: \"center\" !important;\n  background: \"#f5f5f5\" !important;\n  padding: \"0.4rem 0.6rem\" !important;\n  margin-bottom: \"0.8rem\" !important;\n}\n\n.procduct-price-detail-section .ant-image {\n  right: 0.2rem;\n}\n\n.procduct-price-detail-section .sparkles {\n  z-index: 2;\n  position: relative;\n}\n\n.procduct-price-detail-section .range-section {\n  margin-top: 0.6rem;\n}\n\n.procduct-price-detail-section sup .ant-badge-count {\n  color: #000;\n  padding: 1rem;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  padding-left: 1rem;\n}\n\n.product-card-badge {\n  padding: 0.5rem 0.2rem;\n  border-radius: 5px;\n}\n\n.product-card-format-dates-div {\n  display: flex;\n  align-items: center;\n}\n\n.product-card-divider-css {\n  height: 90px;\n  border-color: #b3b5b4;\n}\n\n.product-card-loader {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-right: 4rem;\n  margin-bottom: 1rem;\n}\n\n.card-tooltip {\n  color: rgba(0, 0, 0, 0.85) !important;\n}\n\n.not-available-txt {\n  display: flex;\n  width: 10.6875rem;\n  padding: 0.5rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  color: #0a0f0d;\n  border-radius: 0.3125rem;\n  background: var(--Premium, #ffd700);\n}\n\n.not-available-badge {\n  position: \"absolute\" !important;\n  right: 8 !important;\n  background-color: \"#ffe1e6\" !important;\n  color: \"#d93025\" !important;\n  font-weight: \"600\";\n  font-size: 12;\n  padding: \"8px\";\n  border-radius: 3;\n  user-select: \"none\";\n  pointer-events: \"none\";\n  white-space: \"nowrap\";\n}\n\n.notify-me {\n  font-family: Roboto !important;\n  font-weight: 500 !important;\n  font-style: Medium !important;\n  font-size: 16px !important;\n  line-height: 100%;\n  letter-spacing: 0%;\n  text-decoration: underline !important;\n  text-decoration-style: solid;\n  text-decoration-thickness: 0%;\n  text-decoration-skip-ink: auto;\n  background: none;\n  color: #d2042d !important;\n}\n\n.add-product-section {\n  margin-top: 20px;\n  display: flex;\n  align-items: center;\n}\n\n.product-recomended-type {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Medium;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  text-decoration: underline !important;\n  text-decoration-style: solid;\n  text-decoration-thickness: 0%;\n  text-decoration-skip-ink: auto;\n  background: none;\n  color: #d2042d !important;\n}\n\n.notify-section {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 14px;\n}\n\n.price-range-mobile {\n  position: relative !important;\n  margin-top: 0.2rem;\n  width: max-content;\n}\n\n.estimated-header {\n  width: max-content;\n}\n\n@media (max-width: 1440px) {\n  .toggle-filters {\n    color: #000;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n  }\n\n  .product-last-section-detail-card {\n    display: none !important;\n  }\n\n  .product-card {\n    width: 100%;\n    height: auto;\n    margin-top: 2%;\n  }\n\n  .product-image {\n    width: 100% !important;\n    height: 100% !important;\n  }\n\n  .product-bill-image {\n    width: 28px;\n    height: 27px;\n  }\n\n  .product-id {\n    font-size: 13px;\n    color: #8e9190;\n    padding-right: 30%;\n  }\n\n  .product-availability-desk {\n    display: flex;\n    font-size: 14px !important;\n  }\n\n  .product-card .product-title {\n    font-size: 16px;\n    font-weight: bold;\n  }\n\n  .available-txt {\n    font-size: 13px;\n  }\n\n  .product-availability {\n    font-size: 16px;\n  }\n\n  .product-size-img {\n    width: 28px;\n    height: 27px;\n  }\n\n  .product-size-text {\n    font-size: 16px;\n  }\n\n  .products-metric-icon {\n    width: 24px;\n    height: 24px;\n  }\n\n  .product-reach {\n    font-size: 16px;\n  }\n\n  .product-type {\n    font-size: 16px;\n  }\n\n  .product-last-section-detail {\n    display: flex;\n    justify-content: end;\n    padding-top: 10px;\n    align-items: baseline;\n  }\n\n  .termsplan-section {\n    display: flex;\n    padding-bottom: 15px;\n    align-items: flex-end;\n  }\n\n  .badge-icon {\n    width: 15px;\n  }\n\n  .terms-plan-txt {\n    color: #d2042d;\n    font-size: 15px;\n  }\n\n  .bookmark-icon {\n    width: 15px;\n  }\n\n  .procduct-price-detail-section {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: flex-end !important;\n  }\n\n  .price-text {\n    color: black;\n    font-size: 23px;\n  }\n\n  .per-week {\n    font-size: 13px;\n    color: #8e9190;\n  }\n\n  .middle-specification {\n    margin-top: 0.7rem;\n    background-color: #f8f8f8 !important;\n    display: flex;\n    height: auto;\n    padding: 21px 34px 20px 34px;\n    justify-content: space-between;\n  }\n}\n\n@media (max-width: 1370px) {\n  .product-card-city {\n    font-family: Roboto;\n    font-size: 14px;\n    color: #000;\n  }\n\n  .copy-icon {\n    margin-left: 0px;\n  }\n}\n\n@media (max-width: 1280px) {\n  .terms-plan-txt {\n    color: #d2042d;\n    font-size: 13px;\n  }\n\n  .product-availability {\n    font-size: 13px;\n  }\n\n  .product-id {\n    font-family: Roboto;\n    font-size: 13px;\n    color: #8e9190;\n    padding-right: 0% !important;\n  }\n\n  .product-image {\n    width: 100% !important;\n    height: 100% !important;\n  }\n\n  .format-arrow {\n    padding-top: 2px;\n    padding-inline: 3px;\n  }\n\n  .toggle-filters {\n    color: #000;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n\n  .product-availability-desk {\n    display: flex;\n    font-size: 12px !important;\n  }\n\n  .middle-specification {\n    margin-top: 0.7rem;\n    background-color: #f8f8f8 !important;\n    display: flex;\n    height: auto;\n    padding: 21px 4px 20px 4px;\n    justify-content: space-between;\n  }\n\n  .product-size-text {\n    font-size: 13px;\n  }\n\n  .product-reach {\n    font-size: 13px;\n  }\n\n  .product-type {\n    font-size: 13px;\n  }\n\n  .cards-container {\n    width: 100%;\n  }\n}\n\n@media (max-width: 1024px) {\n  .product-page {\n    padding-left: 10px;\n    padding-right: 2% !important;\n  }\n\n  .cards-container {\n    width: 96vw;\n  }\n\n  /* product listing card css*/\n  .product-size-text {\n    font-size: 13px;\n  }\n\n  .product-image {\n    width: 100% !important;\n    height: 100% !important;\n    padding: 0px 6px;\n    border-radius: 11px !important;\n  }\n\n  .product-id {\n    font-size: 13px;\n    color: #8e9190;\n    padding-right: 4%;\n  }\n\n  .price-text {\n    color: black;\n    font-size: 21px;\n  }\n\n  .ant-select-dropdown .ant-select-item-option-content {\n    font-size: 16px !important;\n  }\n\n  .product-card .ant-select-outlined:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):hover .ant-select-selector {\n    border-color: #c7cac9 !important;\n  }\n\n  .badge-icon {\n    width: 14px !important;\n  }\n\n  .terms-plan-txt {\n    color: #d2042d;\n    font-size: 13px;\n  }\n\n  .bookmark-icon {\n    width: 13px !important;\n  }\n\n  .product-availability {\n    font-size: 14px;\n  }\n\n  .format-arrow {\n    padding-top: 3px;\n    padding-inline: 3px;\n  }\n\n  .product-last-section-detail-card {\n    display: none !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .product-title-mobile-view {\n    font-size: 14px;\n  }\n\n  .border-line-sh {\n    display: none;\n  }\n\n  .products-list-subcontainer {\n    display: none !important;\n  }\n\n  .location-card .ant-card .ant-card-body {\n    padding: 10px !important;\n  }\n\n  .map-location-icon {\n    width: 28px !important;\n    height: 28px !important;\n  }\n\n  .cards-container {\n    width: 93.5vw;\n  }\n\n  .product-last-section-detail-miles {\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n    padding-top: 40px !important;\n  }\n\n  .product-image {\n    width: 100% !important;\n    height: 100% !important;\n  }\n\n  .product-id {\n    font-size: 14px;\n    color: #d2042d;\n  }\n\n  .product-card .product-title {\n    font-size: 20px;\n    font-weight: bold;\n  }\n\n  .available-txt {\n    font-size: 15px;\n    color: #8e9190;\n  }\n\n  .middle-specification {\n    margin-top: 0.7rem;\n    background-color: #f8f8f8 !important;\n    display: flex;\n    height: auto;\n    padding: 21px 34px 20px 34px;\n    justify-content: space-between;\n  }\n\n  .product-availability {\n    font-size: 16px;\n    font-weight: 500;\n  }\n\n  .available-container {\n    padding-top: 7px !important;\n  }\n\n  .product-size-text {\n    font-size: 15px;\n    padding-top: 10px;\n  }\n\n  .product-reach {\n    font-size: 15px;\n    padding-top: 10px;\n  }\n\n  .product-type {\n    font-size: 15px;\n    padding-top: 10px;\n  }\n\n  .product-last-section-detail-card {\n    display: flex !important;\n    justify-content: end !important;\n    height: 60px !important;\n    padding-top: 20px !important;\n    align-items: baseline !important;\n  }\n\n  .product-last-section-detail-map {\n    display: none !important;\n  }\n\n  .product-card .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {\n    background-color: none;\n    border: none;\n    width: none !important;\n    height: 50px;\n    margin-top: 0rem !important;\n    color: rgb(12, 12, 12);\n  }\n\n  .ant-btn:not(:disabled):focus-visible {\n    outline: none !important;\n    outline-offset: 01px !important;\n    transition: none !important;\n  }\n\n  .price-section {\n    display: flex;\n    align-items: flex-end;\n  }\n\n  .navigation-icon {\n    width: 15px !important;\n  }\n\n  .miles-text {\n    font-family: Roboto;\n    color: #8e9190;\n    font-size: 15px;\n  }\n\n  .bookmark-icon {\n    margin-left: 8rem !important;\n    width: 17px !important;\n  }\n\n  .price-text {\n    color: black;\n    font-size: 20px;\n  }\n\n  .ant-pagination:not(.ant-pagination-disabled) .ant-pagination-item:focus-visible {\n    outline: 1px solid #d2042d;\n    outline-offset: 1px;\n    transition:\n      outline-offset 0s,\n      outline 0s;\n  }\n\n  .ant-pagination .ant-pagination-item-active {\n    font-weight: 600;\n    background-color: #ffffff;\n    border-color: #fff;\n  }\n\n  .ant-pagination .ant-pagination-item-active a {\n    color: #d2042d;\n  }\n\n  .product-last-section-detail {\n    display: flex !important;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .product-last-section-detail-map {\n    display: none !important;\n  }\n}\n\n@media (max-width: 425px) {\n  .product-page .ant-card .ant-card-body {\n    padding: 14px;\n    border-radius: 18 0 8px 8px;\n  }\n\n  .product-card .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {\n    background-color: none;\n    border: none;\n    width: none !important;\n    height: 40px;\n    margin-top: 0rem !important;\n    color: rgb(12, 12, 12);\n  }\n\n  .map-location-icon {\n    width: 24px !important;\n    height: 24px !important;\n  }\n\n  .map-location-icon {\n    width: 24px !important;\n    height: 24px !important;\n  }\n\n  .product-image {\n    width: 100% !important;\n    height: 100% !important;\n  }\n\n  .product-id {\n    font-size: 13px !important;\n    color: #d2042d;\n    font-weight: 500;\n  }\n\n  .bookmark-icon {\n    margin-left: 41px !important;\n    width: 17px !important;\n  }\n\n  .product-card .product-title {\n    font-size: 16px !important;\n    font-weight: bold;\n  }\n\n  .available-txt {\n    font-size: 13px;\n    color: #8e9190;\n  }\n\n  .product-availability {\n    font-size: 13px;\n    font-weight: 600;\n    display: flex;\n  }\n\n  .middle-specification {\n    display: flex;\n    height: 100%;\n    padding: 21px 0px 20px 0px !important;\n    justify-content: space-evenly;\n    flex-shrink: 0;\n  }\n\n  .product-size-img {\n    width: 20px;\n    height: 19px;\n  }\n\n  .product-size-text {\n    font-size: 13px;\n    text-align: center;\n  }\n\n  .products-metric-icon {\n    width: 20px;\n    height: 20px;\n  }\n\n  .product-reach {\n    font-size: 13px;\n  }\n\n  .product-type {\n    font-size: 13px;\n  }\n\n  .navigation-icon {\n    width: 13px !important;\n  }\n\n  .miles-text {\n    color: #8e9190;\n    font-size: 13px;\n  }\n\n  .price-text {\n    color: black;\n    font-size: 19px;\n    font-weight: 700 !important;\n  }\n}\n\n@media (max-width: 375px) {\n  .product-image {\n    width: 100% !important;\n    height: 100% !important;\n    border-radius: 10px !important;\n  }\n\n  .available-container {\n    padding-top: 0px !important;\n  }\n\n  .bookmark-icon {\n    margin-left: 18px !important;\n    width: 17px !important;\n  }\n\n  .middle-specification {\n    display: flex;\n    height: auto;\n    padding: 15px 0px 19px 0px !important;\n    justify-content: space-evenly;\n    flex-shrink: 0;\n  }\n}\n\n@media (max-width: 360px) {\n  .bookmark-icon {\n    margin-left: 8px !important;\n    width: 17px !important;\n  }\n\n  .product-availability-desk {\n    display: flex;\n    font-size: 13px !important;\n  }\n\n  .per-week {\n    font-size: 11px;\n    color: #8e9190;\n  }\n}\n\n/* CSS for the Desktop Product Details Modal */\n.divider-line {\n  margin-top: 20px;\n  width: 100%;\n  border: 1px solid #d2d2d2;\n}\n\n.close-icon {\n  color: #d2042d;\n  font-size: 30px;\n  justify-content: center;\n  font-weight: 3px;\n}\n\n.checkboard-availability-heading {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  color: #000;\n  font-family: Roboto;\n  font-size: 23px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  padding-top: 2rem;\n  padding-left: 1.8rem;\n  padding-bottom: 0.1rem;\n}\n\n.modal-style .ant-modal-content {\n  display: flex;\n  box-shadow: none !important;\n  padding: 0px !important;\n  padding-top: 30px;\n  height: auto;\n  justify-content: center !important;\n  width: 100%;\n  overflow-y: auto;\n  flex-direction: column;\n  border-radius: 10px;\n  background: #fff;\n}\n\n.mobile-promo {\n  min-width: 0;\n  width: 96%;\n  border-radius: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
